<div>
  <div class="title title--big">Мониторинг работы участков</div>
</div>

<div class="mt-32 padding-24 pos-r" *ngIf="monitoringDataUnionLoading">
  <app-loader></app-loader>
</div>

<div *ngIf="!monitoringDataUnionLoading">
  <div class="mt-32">
    <app-monitoring-filter [filter]="filter"></app-monitoring-filter>
  </div>

  <div class="mt-32">
    <table class="tbl tbl--full tbl--hovered">
      <colgroup>
        <col width="4%" />
        <col width="12%" />
        <col width="12%" />
        <col />
        <col />
        <col width="6%" />
      </colgroup>
      <thead>
        <tr>
          <th>Участок</th>
          <th>Регион</th>
          <th>Филиал</th>
          <th>Район</th>
          <th>Роль участка</th>
          <th>Диспетчер</th>
          <th>Действия</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="sectorsDataLoading">
          <td colspan="6">
            <div class="padding-24 pos-r">
              <app-loader></app-loader>
            </div>
          </td>
        </tr>
        <ng-container *ngIf="!sectorsDataLoading">
          <tr *ngFor="let sector of sectors">
            <td>{{ sector.sector_number_str }}</td>
            <td>{{ sector.market_branch.mb_region }}</td>
            <td>{{ sector.market_branch.mb_name }}</td>
            <td>
              <span *ngFor="let city of sector.districts; let dlast = last">
                <span class="font-weight-bold">{{ city.ct_name }}: </span>
                <span *ngFor="let last = last; let district; of: city.districts">{{ district.district_name }}{{ last ? '' : ', ' }}</span
                >{{ dlast ? '' : '; ' }}
              </span>
            </td>
            <td>
              {{ sector.sector_role | func : formatSectorRole }}
            </td>
            <td>
              <span *ngFor="let dispatcher of sector.dispatchers; let dispatcherLast = last">
                {{ dispatcher.employee.full_name }}
                {{ dispatcherLast ? '' : ', ' }}
              </span>
            </td>
            <td>
              <a
                class="link link--dotted-gray-dark"
                [ngbPopover]="actionsPopContent"
                placement="bottom-right"
                triggers="manual"
                #p2="ngbPopover"
                (click)="toggleWithActionsContext(p2, sector)"
                >открыть</a
              >
            </td>
          </tr>
        </ng-container>
        <ng-container *ngIf="(!sectorsDataLoading && !sectors) || (sectors && !sectors.length)">
          <tr *ngFor="let sector of sectors">
            <td colspan="6">
              <div class="padding-48 pos-r ta-center">
                <span class="color-gray text-itelic">Нет данных для отображения</span>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div class="mt-32 pagination__block">
      <button
        type="button"
        class="button pagination__block-button"
        id="appPaginationPlot"
        (click)="getSectors()"
        *ngIf="sectors && sectors.length < paginationBlock.filterDataMaxRows"
      >
        Показать еще {{ paginationBlock.countShowPlots }} записей ({{ sectors.length }} из {{ paginationBlock.filterDataMaxRows }})
      </button>
      <div class="pagination__block-list">
        <div class="grid">
          <div class="grid__box grid__box--size-min">Показывать по:</div>
          <div class="grid__box grid__box--size-min" *ngFor="let count of paginationBlock.limits">
            <span
              [ngClass]="{
                'link link--dotted-gray-dark': count !== paginationBlock.countShowPlots
              }"
              (click)="onChangeLimitCountShowPlots(count)"
            >
              {{ count }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #actionsPopContent>
  <div class="mt-4 mb-4">
    <a class="link" target="_blank" [routerLink]="['/', WORK_SHIFTS_PATHS.work_shifts, { sector_id: sectorOpenedActions.sector_id }]"> График рабочих смен участка </a>
  </div>
  <div class="mt-4 mb-4">
    <a
      class="link"
      target="_blank"
      [routerLink]="['/', WORK_SHIFT_PATHS.work_shift, WORK_SHIFT_PATHS.work_shift_s, sectorOpenedActions.sector_id, WORK_SHIFT_PATHS.work_shift_worker_statuses]"
      >Смена участка</a
    >
  </div>
</ng-template>
